import type { Payment } from '@lombok/shared';
import { AccountName } from '@/components/AccountName';

/**
 * The sub-account a payment belongs to, for the distributor portal. A payment made on the
 * distributor's own account has no sub-account, and its id is never shown in its place.
 */
export function SubaccountName({ payment }: { payment: Payment }) {
  if (payment.accountType === 'distributor') return <>Cuenta propia</>;
  return <AccountName id={payment.accountId} />;
}
